import { useEffect, useState } from 'react'
import { Box, Stack, Menu, MenuItem, SvgIcon, Typography } from '@mui/material'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { 
  dropdownIconPath,
} from '../common/iconPaths'
import custom from '../../styles/mui/szVariables.json'


export default function MobileNavigation({
    navItemList,
    title,
    itemSelected,
    defaultSelected,
    handleMenuClick
  }: any) {
    const [selected, setSelected] = useState(defaultSelected);
    const [menuContextEl, setMenuContextEl] = useState(null);
    const colorSelected = "primary.main";
 
    useEffect(() => {
      if( selected !== itemSelected ) {
        setSelected(itemSelected)
      }
    },[selected, itemSelected])

    const handleMenuSelected = (event: any) => {
      setMenuContextEl(null);
      handleMenuClick(event)
    };

    const handleMenuShow = (event: any) => {
        setMenuContextEl(event.currentTarget);
      };

    return (
      <>
      <Box 
        top={'72px'} 
        maxHeight={custom.sizes.hf} 
        position={{
          xs: "fixed",
          sm: "sticky",
          md: "sticky",
          lg: "relative",
        }}
        borderBottom={{
          xs: custom.border,
          sm: 0, md: 0, lg: 0
        }}
        pt={{
          xs: custom.spacing.sm,
          sm: 0, md: 0, lg: 0
        }}
        width="100%"
        sx={{
          backgroundColor: 'sz.colors.background',
          boxSizing: 'border-box',
          zIndex: 99
        }}
        justifyContent={"center"}>
       <Stack alignItems="flex-end" direction="row"
              justifyContent="flex-end" 
              sx={{
                pb: '21px',
                px:custom.spacing.md
              }}>
            <Typography component="h3" 
              variant='szHeading.Bold.Small'>
              {title}
            </Typography>
            <Box ml="auto">
              <Stack alignItems="center"
                    direction="row" 
                    justifyContent="flex-end"
                    id="mobileMenu"
                    onClick={handleMenuShow}
                    sx={{
                      cursor: 'pointer'
                    }}
                    
                  >
                  <SvgIcon onClick={handleMenuShow}
                      sx={{
                        color: colorSelected, 
                        fontSize: '1.5rem',
                        zIndex: 999 
                      }}> 
                    {itemSelected?.selected} 
                  </SvgIcon>
                  <Typography sx={{ 
                      color: colorSelected, 
                      pl: custom.spacing.xxxs,
                    }} 
                    variant="szHeading.Regular.xSmall" > 
                    {itemSelected?.name}
                  </Typography>
                  <SvgIcon sx={{
                        ml: custom.spacing.xxs,
                        color: colorSelected, 
                        pt: custom.spacing.xxxxs
                      }}> 
                  {dropdownIconPath} 
                </SvgIcon>
              </Stack>
            </Box>
        </Stack>       
      </Box>
      <Menu slotProps={{
        paper: { 
          sx:{ 
            borderRadius: custom.corners5, 
            minWidth: '210px', 
            cursor: 'pointer' 
          }
        }}}
        id={`menu-${title}`}
        anchorEl={menuContextEl}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
        }}
        open={Boolean(menuContextEl)}
        onClose={()=>{setMenuContextEl(null);}}
    >
        <Box p={custom.spacing.sm}>
          <Typography  variant="szHeading.Bold.Small" >
            {title}
          </Typography>
        </Box>
        {navItemList.map((item: any)=>(
          <MenuItem id={`${item.id}Mobile`} key={item.id} 
              onClick={handleMenuSelected}
              sx={{
                '&:hover': {
                  backgroundColor: 'sz.colors.hover',
                  boxShadow: 'none'
              }}}>
              <Box width={"100%"} >
                <Stack alignItems="start" 
                    direction="row" 
                    justifyContent="flex-start"
                    py="12px">
                    <Stack alignItems="center" 
                        direction="row" 
                        justifyContent="flex-end" >
                        <SvgIcon 
                            sx={{ color: `${item.id===selected?
                                  colorSelected:item.id!=='signout'?
                                  'inherit':'error.main'}` 
                              }}>
                            {item.id===selected?item.selected:item.iconPath} 
                        </SvgIcon>
                        <Typography 
                          pl={custom.spacing.xxs}
                          variant="szHeading.Regular.xSmall" 
                          sx={{ color: `${item.id===selected?
                                      colorSelected:item.id!=='signout'?
                                      'inherit':'error.main'}` 
                                  }}> 
                            {item.name}
                        </Typography>
                    </Stack>
                    {item.id!=='signout'?
                    <ArrowForwardIosIcon sx={{ 
                      ml: 'auto',  
                      pt: "5px",  
                      height: '1rem', 
                      color: `${item.id===selected?colorSelected:'inherit'}`}}/>
                      :<></>}
                </Stack>
              </Box>
          </MenuItem>
        ))}
      </Menu>
      </>
    )
}